// LocationDialog.js

import React, { useCallback, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { DEFAULTLOCATION, bookingRegionState } from 'pages/CustomerBookingCreate/state';
import { useRecoilState } from 'recoil';
import { Menu } from "@material-ui/core";
import { LocationCity } from '@material-ui/icons';
import { MenuItem } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { useTrackEvent } from 'util/trackEvent';

const RegionSetter = () => {

  const trackEvent = useTrackEvent()

  const [selectedRegion, setSelectedRegion] = useRecoilState(bookingRegionState);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    trackEvent('Create Booking Service List - Open service location selection')
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(
    async () => {
      setAnchorEl(null);
    }, [DEFAULTLOCATION]
  );

  const handleSelect = useCallback(
    async (value) => {
      setSelectedRegion(DEFAULTLOCATION[value])
      trackEvent('Create Booking Service List - Select service location', { location: value}, {retainProps: true})
      handleClose()
      return null
    }, [DEFAULTLOCATION]
  );

  return (
    <div>
      <Button
        
        variant='contained'
        fullWidth
        color='primary'
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
        startIcon={<LocationCity />}
      >
        <div style={{
          display: "flex",
          flexDirection: 'column',
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <Typography 
          variant='caption'
          >
            Service Location
          </Typography>
          <b>
            {selectedRegion?.location?.identifier}
          </b>
        </div>

      </Button>
      <Menu
        id="simple-menu"
        variant="menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          selected={ selectedRegion?.location?.identifier === 'Metro Manila'}
          onClick={() => handleSelect("Metro Manila")}
        >
          Metro Manila
        </MenuItem>
        <MenuItem
          selected={ selectedRegion?.location?.identifier === 'Metro Cebu'}
          onClick={() => handleSelect("Metro Cebu")}
        >
          Metro Cebu
        </MenuItem>
      </Menu>
    </div>
  );
};

export { RegionSetter };